import React, { FC } from 'react';
import { useInView } from 'react-intersection-observer';
import { LinkTrackable } from 'components/Trackable/LinkTrackable';
import icons from 'style';
import { CardWrapper } from 'components/Lane/Lane.css';
import { ChannelCover } from 'types/Cover';
import { CardChannelContent } from 'components/Cards/Card/parts/CardChannelContent';
import { cardVariantCss } from 'components/Cards/Card/Card.css';
import { CardVariant, cardSpec } from 'components/Cards/Card/cardVariants';
import { CardChannelWrapperInner } from './CardChannel.css';

export const CardChannel: FC<{ asset: ChannelCover }> = ({ asset, ...rest }) => {
    const spec = cardSpec(CardVariant.CHANNEL);
    const { path, number, subscription, favorite, title, image } = asset;

    const [ref, inView] = useInView({
        /* Optional options */
        threshold: 0,
    });

    return (
        <CardWrapper height={'auto'} width={'auto'} variantCss={cardVariantCss(spec)} ref={ref}>
            {inView && (
                <LinkTrackable
                    to={path}
                    onClick={(e) => {
                        if (asset.onClick) {
                            asset.onClick(e, asset.rawData);
                        }
                    }}
                    visibleFocus="outline"
                    style={{ position: 'absolute', width: 'inherit', height: 'inherit' }}
                    {...rest}
                >
                    <CardChannelWrapperInner>
                        <CardChannelContent
                            number={number}
                            title={title}
                            image={image}
                            subscription={subscription}
                            favorite={favorite}
                            favoriteIcon={icons.icoFavorite}
                            withArrowAnchor
                        />
                    </CardChannelWrapperInner>
                </LinkTrackable>
            )}
        </CardWrapper>
    );
};
